import PersonaView from "./PersonaView";

export {PersonaView}
export default PersonaView
